import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  $color8,
  $10pt,
  $semiBold,
} from '../styles/Variables';
import { getCompanyThemeData } from '../Theme';

export const useStyles = makeStyles((theme: Theme) => {
  const companyTheme = getCompanyThemeData();
  return createStyles({
    label: {
      marginBottom: theme.spacing(0.5),
      color: $color8,
      fontSize: $10pt,
      fontWeight: $semiBold,
    },
    textField: {
      root: {
        '&$focused': {
          color: '#000',
        },
      },
      focused: {},
      '& input[placeholder]': {
        textOverflow: 'ellipsis',
      },
    },
    spinner: {
      padding: 0,
      backgroundColor: 'unset !important',
      position: 'absolute',
      right: '6px',
    },
    formHelperText: {
      marginLeft: 0,
    },
    // Focused outline color override
    cssOutlinedInput: {
      '&$cssFocused $notchedOutline': {
        borderColor: `${companyTheme.primaryColor} !important`,
      },
    },
    cssFocused: {},
    notchedOutline: {},
  });
});

export default useStyles;
